<template>
  <a
    :href="category.url"
    :class="className"
    class="help-center-post-tree-heading__component"
  >
    <i
      v-if="category.card"
      class="help-center-post-tree-heading__card-icon"
      :class="category.icon"
      :style="category.icon_style"
    />
    <i
      v-else-if="nested"
      class="help-center-post-tree-heading__nested-icon"
      :class="category.icon"
    />
    <div
      v-else
      class="help-center-post-tree-heading__root-icon-background"
    >
      <i
        class="help-center-post-tree-heading__root-icon"
        :class="category.icon"
      />
    </div>
    <div class="help-center-post-tree-heading__column">
      <div class="help-center-post-tree-heading__title-with-icon">
        <h2 class="help-center-post-tree-heading__title">
          {{ category.title }}
        </h2>
        <HelpCenterIcon
          class="help-center-post-tree-heading__title-icon"
          name="external-link"
          size-units="3"
        />
      </div>
      <p
        v-if="!nested"
        class="help-center-post-tree-heading__description"
      >
        {{ category.description }}
      </p>
    </div>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterIcon from 'help-center/components/HelpCenterIcon'

const props = defineProps({
  nested: {
    type: Boolean,
    required: true
  },
  category: {
    type: Object,
    required: true
  }
})

const className = computed(() => {
  if (props.nested) {
    return 'help-center-post-tree-heading__component--nested'
  } else {
    return null
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-tree-heading {
  &__component {
    @include help-center-accent-link($selector: '.help-center-post-tree-heading__title');

    gap: 12px;
    display: inline-flex;
    flex-direction: row;

    @include help-center-breakpoint(md) {
      flex-direction: column;
    }

    &--nested {
      gap: 8px;
      align-items: center;
      flex-direction: row;
    }
  }

  &__root-icon-background {
    // visual alignment with the text
    margin-top: 5px;

    @include help-center-breakpoint(md) {
      margin-top: 0;
    }
  }

  &__root-icon-background {
    display: flex;
    align-items: center;
    justify-content: center;

    flex: none;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background-color: var(--help-center-icon-bg);
  }

  &__card-icon {
    @include help-center-icon(48);
    flex: none;
  }

  &__nested-icon {
    @include help-center-icon(16);
    flex: none;
  }

  &__root-icon {
    @include help-center-icon(24);
    color: var(--help-center-highlight);
    padding: 4px;
  }

  &__column {
    display: flex;
    flex-direction: column;

    @include help-center-breakpoint(md) {
      gap: 4px;
    }
  }

  &__title-with-icon {
    gap: 4px;
    display: flex;
    align-items: baseline;
  }

  &__title {
    @include help-center-font(18, title);
    font-weight: var(--help-center-bold);
  }

  &__title-icon {
    flex: none;
  }

  &__description {
    @include help-center-font(14);
    color: var(--help-center-muted);
    text-wrap: balance;
  }
}
</style>
